






import Vue from 'vue';

export default Vue.extend({
  data: () => ({
    title: "",
    body: ""
  }),
  methods:{
    initPage(){

      if( this.$route.params.id ) {
        let group = this.$store.state.contents.group;
        if( group && group[this.$route.params.id] ){
          let content = group[this.$route.params.id].content;
          if( content && content[this.$route.params.name] ){
            this.title = content[this.$route.params.name].title;
            this.body = content[this.$route.params.name].body;
          }
        }

      }else if( this.$route.params.name ){
        let content = this.$store.state.contents.content;
        if( content && content[this.$route.params.name] ){
          this.title = content[this.$route.params.name].title;
          this.body = content[this.$route.params.name].body;
        }
      }

      if( ! this.body ){
        this.title = "خطا";
        this.body = "صفحه مورد نظر یافت نشد ...";
      }
    }
  },
  mounted() {
    this.initPage();
  },
  watch:{
    '$route.path': function (){
      this.initPage();
    }
  }
});
